import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';

@Component({
    selector: 'tt-check-in-menu',
    templateUrl: './check-in-menu.component.html',
    styleUrls: ['./check-in-menu.component.css'],
})
export class CheckInMenuComponent implements OnInit {
    public argType;

    public argValue;

    public menu?: Menu;

    constructor(
        private stateService: StateService,
        private datatask: DataTaskService,
        private modal: ModalService,
    ) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadMenu() {
        if (!!this.argType && !!this.argValue) {
            this.menu = (
                await this.datatask.Post(507, {
                    argtype: this.argType,
                    argvalue: this.argValue,
                })
            )[0];
        }
    }

    public checkIn() {
        this.checkedIn('I');
    }

    public checkOut() {
        this.checkedIn('O');
    }

    public checkedInGuard() {
        this.checkedIn('G');
    }

    public checkedOutGuard() {
        this.checkedIn('F');
    }

    private async checkedIn(status: string) {
        switch (status) {
            case 'I':
            case 'O':
            case 'G':
            case 'F':
                // console.log('checkedIn');
                // const permission = await navigator.permissions.query({ name: 'geolocation' });

                // if (permission.state === 'denied') {
                //     this.modal.show({ type: 'danger', title: 'error', translateTitle: true, message: error.message });
                // }

                this.datatask
                    .Post(506, {
                        inout: status,
                        argtype: this.argType,
                        argvalue: this.argValue,
                        latitude: 0,
                        longitude: 0,
                        accurancy: 0,
                    })
                    .then(() => {
                        this.loadMenu();
                    });

                // try {
                //     navigator.geolocation.getCurrentPosition(
                //         (data) => {
                //             console.log(data);
                //             this.datatask
                //                 .Post(506, {
                //                     inout: status,
                //                     argtype: this.argType,
                //                     argvalue: this.argValue,
                //                     latitude: data.coords.latitude,
                //                     longitude: data.coords.longitude,
                //                     accurancy: data.coords.accuracy,
                //                 })
                //                 .then(() => {
                //                     this.loadMenu();
                //                 });
                //         },
                //         (error) => {
                //             console.error(error);
                //             console.dir(error);
                //         },
                //         { timeout: 10000 },
                //     );
                // } catch (error) {
                //     console.error(error);
                //     console.dir(error);
                // }
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    statusmessage: string;
    user_name: string;
    checkedin: string;
    nbr_of_checkedin: string;
    show_setting: string;
    show_button_show_all: string;
    show_guard: string;
    statusmessage_guard: string;
    checkedin_guard: string;
    guard_heading: string;
    nbr_of_checkedin_guard: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('checkInMenu', {
//        templateUrl: 'views/components/views/checkInMenu/checkInMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'checkInMenuService', function ($stateParams, checkInMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                argType: argType,
//                argValue: argValue,
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await checkInMenuService.getMenu({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region CHECK IN BUTTON FUNCTIONS

//            vm.checkIn = function () {
//                checkedIn('I');
//            };

//            vm.checkOut = function () {
//                checkedIn('O');
//            };

//            vm.checkedInGuard = function () {
//                checkedIn('G');
//            };

//            vm.checkedOutGuard = function () {
//                checkedIn('F');
//            };

//            // #endregion CHECK IN BUTTON FUNCTIONS

//            // #region CHECK IN MULTI PROCEDURE FUNCTION CALLS

//            function checkedIn(status) {
//                switch (status) {
//                    case 'I':
//                    case 'O':
//                    case 'G':
//                    case 'F':
//                        navigator.geolocation.getCurrentPosition(function (data) {
//                            checkInMenuService.checkInOutPortalUser({
//                                inout: status,
//                                argtype: argType,
//                                argvalue: argValue,
//                                latitude: data.coords.latitude,
//                                longitude: data.coords.longitude,
//                                accurancy: data.coords.accuracy
//                            }).then(function () {
//                                loadMenu();
//                            });
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion CHECK IN MULTI PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
